export default function PHP_Compiler() {
  return (
    <div>
      <h1>PHP_Compiler</h1>
    </div>
  );
}
